import React, { useRef, useState, useEffect } from 'react'
import { Link } from 'react-router-dom'

//Importing Assets
import EXPERTISE from '../../Assets/images/expertiseIMG.png'
import EXPERTISEWHITE from '../../Assets/images/expertiseIMGWhite.png'
import COMMITMENT from '../../Assets/images/commitmentIMG.png'
import FOCUS from '../../Assets/images/focusIMG.png'
import FOCUSWHITE from '../../Assets/images/focusIMGWhite.png'
import COMPREHENSIVE from '../../Assets/images/comprehensiveIMG.png'
import PROACTIVE from '../../Assets/images/proactiveIMG.png'
import PROACTIVEWHITE from '../../Assets/images/proactiveIMGWhite.png'
import CUSTOMER from '../../Assets/images/customerIMG.png'

import BANNERMODEL from '../../Assets/images/bannerModel.png'

import TAX from '../../Assets/images/Services Section/taxConsultancy.jpg'
import GST from '../../Assets/images/Services Section/gstRegistration.jpg'
import ITR from '../../Assets/images/Services Section/itrFiling.jpg'
import MANYMORE from '../../Assets/images/Services Section/manyMore.jpg'

import GSTICN from '../../Assets/images/Pricing Section/gst.png'
import FILINGICN from '../../Assets/images/Pricing Section/filing.png'
import TAXICN from '../../Assets/images/Pricing Section/tax.png'
import REGICN from '../../Assets/images/Pricing Section/registration.png'
import LICICN from '../../Assets/images/Pricing Section/license.png'

//Importing Clients LOGO
import CLIENT1 from '../../Assets/images/Clients Section/client_logo1.png'
import CLIENT2 from '../../Assets/images/Clients Section/client_logo2.png'
import CLIENT3 from '../../Assets/images/Clients Section/client_logo3.png'
import CLIENT4 from '../../Assets/images/Clients Section/client_logo4.png'
import CLIENT5 from '../../Assets/images/Clients Section/client_logo5.png'
import CLIENT6 from '../../Assets/images/Clients Section/client_logo6.png'

//Importing FontAwesome
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faAngleLeft, faAngleRight, faArrowRight, faQuoteLeft, faUser } from '@fortawesome/free-solid-svg-icons'

//Importing Styles
import './homePageStyle.css'
import './servicesSectionStyle.css'
import './pricingSectionStyle.css'
import './chooseusSectionStyle.css'
import './clientsSectionStyle.css'
import './newBannerStyle.css'
import './newPricingSectionStyle.css'
import './testimonialsSectionStyle.css'

//Importing Components
import RequestCallbackForm from '../../Components/Contact/RequestCallbackForm'
import SideButtons from '../../Components/SideButtons/SideButtons'
import HomePageBanner from '../../Components/HomePageBanner/HomePageBanner'

//Importing GSAP for Animation
import gsap from 'gsap'; // <-- import GSAP
import { useGSAP } from '@gsap/react'; // <-- import the hook from our React package
import ScrollTrigger from 'gsap/dist/ScrollTrigger'

gsap.registerPlugin(useGSAP)
gsap.registerPlugin(ScrollTrigger)

const Homepage = ({ states, toggleModes }) => {

    //Refs
    const bannerContainer = useRef(null)
    const about = useRef(null)
    const services = useRef(null)
    const pricing = useRef(null)
    const chooseUs = useRef(null)
    const faq = useRef(null)
    const visitUs = useRef(null)
    const testimonials = useRef(null)

    //Variables
    const [requestFormDisplay, setrequestFormDisplay] = useState({ status: false, data: '' })
    const CATEGORIES = [
        {
            title: 'Registrations',
            icon: REGICN,
            items: ['TAN', 'PAN', 'MSME'],
            bgColor: '#c8effe32'
        },
        {
            title: 'Licenses',
            icon: LICICN,
            items: ['Trade', 'Food', 'Fire'],
            bgColor: '#cbffec32'
        },
        {
            title: 'TDS Preparation',
            icon: TAXICN,
            items: ['Salary', 'NRI', 'Others'],
            bgColor: '#c1e9f432'
        },
        {
            title: 'GST Filing',
            icon: GSTICN,
            items: ['GSTR 1', 'GSTR 3B', 'GSTR-9'],
            bgColor: '#e8e8e862'
        },
        {
            title: 'IT Filing',
            icon: FILINGICN,
            items: ['PVT LTD', 'NRI', 'Others'],
            bgColor: '#ffcf6622'
        },
    ]
    const REVIEWS = [
        {
            client_name: "Amit Verma",
            client_company_name: "Verma Textiles Pvt. Ltd.",
            review: "Absolutely professional and efficient service. The team handled our GST registration smoothly and clarified all our doubts. Highly recommended for startups and growing businesses."
        },
        {
            client_name: "Ritika Shah",
            client_company_name: "Shah Enterprises",
            review: "We used their services for IT filing and TDS preparation. The process was streamlined, and their communication was top-notch. Saved us a lot of time and effort."
        },
        {
            client_name: "Rohit Mehra",
            client_company_name: "Mehra Digital Solutions",
            review: "They helped us register multiple licenses for our new operations and ensured we stayed compliant. Truly a one-stop solution for legal and tax-related services."
        },
        {
            client_name: "Priya Nair",
            client_company_name: "Nair & Co. Exports",
            review: "The firm is very responsive and knowledgeable. They handled our GST registration and annual tax filing flawlessly. Very satisfied with their legal advisory services."
        },
        {
            client_name: "Karan Malhotra",
            client_company_name: "Malhotra Builders",
            review: "Professionalism at its best! They ensured our TDS and IT filings were submitted ahead of deadlines. Their team is reliable and very supportive."
        },
        {
            client_name: "Neha Joshi",
            client_company_name: "Joshi Wellness Studio",
            review: "From license registration to handling our GST returns, everything was done accurately and quickly. Great experience working with this legal support team."
        }
    ]

    //Animation
    useGSAP(
        (context, contextSafe) => {
            // gsap code here...
            const bannerAnimation = gsap.timeline()
            bannerAnimation.from(bannerContainer.current.querySelector('.modelContainer'), { x: '70%', opacity: 0, duration: 0.4, ease: "back.out(1.7)", }) // <-- automatically reverted
                .from(bannerContainer.current.querySelector('.contentContainer .content h5'), { x: '-50%', opacity: 0, duration: 0.4 })
                .from([bannerContainer.current.querySelector('.contentContainer .content h2'), bannerContainer.current.querySelector('.contentContainer .content p')], { x: "-50%", opacity: 0, duration: 0.5, stagger: 0.5 })
                .from(bannerContainer.current.querySelectorAll('.contentContainer .buttonsContainer a'), { scale: 0, opacity: 0, duration: 0.2, ease: "back.out(2)", stagger: 0.2 })

            let aboutAnimation = gsap.timeline({
                scrollTrigger: {
                    trigger: about.current,
                    start: "top 60%",
                }
            });

            aboutAnimation.from(about.current.querySelector('.aboutus_content'), { x: -200, opacity: 0, duration: 0.5 })
                .from(about.current.querySelector('.image_container'), { x: 200, opacity: 0, duration: 0.5 })

            let servicesAnimation = gsap.timeline({
                scrollTrigger: {
                    trigger: services.current,
                    start: "top 50%",
                }
            });

            servicesAnimation.from([services.current.querySelector('.col1 h2'), services.current.querySelector('.col1 p')], { x: -200, opacity: 0, duration: 0.3 })
                .from(services.current.querySelectorAll('.col1 ul li'), { y: -50, opacity: 0, duration: 0.3, stagger: 0.2 })
                .from(services.current.querySelectorAll('.col2 .card_container'), { scale: 0, duration: 0.3, delay: -1, stagger: 0.2 })
                .from(services.current.querySelectorAll('.col1 .submit-button'), { scaleX: 0, duration: 0.3 })

            let pricingAnimation = gsap.timeline({
                scrollTrigger: {
                    trigger: pricing.current,
                    start: "top 50%",
                }
            })

            // pricingAnimation.from(pricing.current.querySelector('.heading h4'), { y: 20, opacity: 0, duration: 0.3 })
            //     .from(pricing.current.querySelector('.heading p'), { y: -20, opacity: 0, duration: 0.3 })
            //     .from(pricing.current.querySelectorAll('.slider_container .card'), { scale: 0, duration: 0.5, delay: -0.3, stagger: 0.4 })
            //     .from(pricing.current.querySelector('.footing .submit-button'), { x: -200, opacity: 0, duration: 0.5 })

            pricingAnimation.from(pricing.current.querySelector('.heading h4'), { y: 20, opacity: 0, duration: 0.3 })
                .from(pricing.current.querySelector('.heading p'), { y: -20, opacity: 0, duration: 0.3 })
                .from(pricing.current.querySelectorAll('.card_container .category_card'), { scale: 0, duration: 0.5, delay: -0.3, stagger: { each: 0.2, from: 'random' }, ease: "elastic.out(0.5,0.4)" })
                .from(pricing.current.querySelector('.footing .submit-button'), { x: -200, opacity: 0, duration: 0.5 })

            let chooseusAnimation = gsap.timeline({
                scrollTrigger: {
                    trigger: chooseUs.current,
                    start: "top 50%",
                }
            })

            chooseusAnimation.from(chooseUs.current.querySelector('.heading h4'), { y: 20, opacity: 0, duration: 0.4 })
                .from(chooseUs.current.querySelector('.heading p'), { y: -20, opacity: 0, duration: 0.3 })
                .from(chooseUs.current.querySelectorAll('.container .card'), { x: -100, opacity: 0, duration: 0.5, stagger: 0.3 })

            let faqAnimation = gsap.timeline({
                scrollTrigger: {
                    trigger: faq.current,
                    start: "top 70%",
                }
            })

            faqAnimation.from(faq.current.querySelector('.heading h4'), { x: -100, opacity: 0, duration: 0.4 })
                .from(faq.current.querySelector('.heading p'), { x: 100, opacity: 0, duration: 0.3 })
                .from(faq.current.querySelectorAll('.question_container div'), { y: -100, opacity: 0, duration: 0.5, stagger: 0.15 })


            let testimonialAnimation = gsap.timeline({
                scrollTrigger: {
                    trigger: testimonials.current,
                    start: "top 50%",
                }
            })

            testimonialAnimation.from(testimonials.current.querySelector('.testimonials_heading h4'), { x: -100, opacity: 0, duration: 0.4 })
                .from(testimonials.current.querySelector('.testimonials_heading p'), { x: 100, opacity: 0, duration: 0.3 })
                .from(testimonials.current.querySelectorAll('.carousel-container .testimonial_card'), { y: 50, opacity: 0, duration: 0.5, stagger: 0.15 })
                .from(testimonials.current.querySelectorAll('.carousel-btn'), { scale: 0, opacity: 0, duration: 0.3, stagger: 0.15 })

            let visitusAnimation = gsap.timeline({
                scrollTrigger: {
                    trigger: visitUs.current,
                    start: "top 60%",
                }
            })

            visitusAnimation.from(visitUs.current.querySelector('.visitus_heading'), { y: 20, opacity: 0, duration: 0.4 })
                .from(visitUs.current.querySelectorAll('.content_container .content div'), { x: -100, opacity: 0, duration: 0.5, stagger: 0.2 })
        },
        { scope: bannerContainer, services, pricing, faq, about, chooseUs, visitUs }
    ); // <-- scope for selector text (optional)


    //Functions
    const handleRequestForm = (serviceType = '') => {
        if (requestFormDisplay.status) {
            setrequestFormDisplay({ status: false, data: '' })
            //UnLock Scroll
            document.body.style.overflow = '';
        } else {
            setrequestFormDisplay({ status: true, data: serviceType })
            //Lock Scroll
            document.body.style.overflow = 'hidden';
        }
    }


    const trackRef = useRef(null);
    const [itemsPerView, setItemsPerView] = useState(0);
    const [currentIndex, setCurrentIndex] = useState(0);

    // Handle responsive layout
    useEffect(() => {
        const handleResize = () => {
            let viewCount = 3;
            if (window.innerWidth <= 600) viewCount = 1;
            else if (window.innerWidth <= 900) viewCount = 2;
            setItemsPerView(viewCount);
        };

        handleResize();
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    // Update carousel position
    useEffect(() => {
        const track = trackRef.current;
        if (track && track.children.length > 0) {
            const itemWidth = track.children[0].getBoundingClientRect().width;
            track.style.transition = "transform 0.8s ease";
            track.style.transform = `translateX(-${itemWidth * currentIndex}px)`;
        }
    }, [currentIndex]);

    const handleNext = () => {
        const maxIndex = REVIEWS.length - itemsPerView;
        if (window.innerWidth <= 600) setCurrentIndex((prevIndex) => (prevIndex >= maxIndex ? 0 : prevIndex + 1));
        else if (window.innerWidth <= 900) setCurrentIndex((prevIndex) => (prevIndex >= maxIndex ? 0 : prevIndex + 2));
        else setCurrentIndex((prevIndex) => (prevIndex >= maxIndex ? 0 : prevIndex + 3));
    };

    const handlePrev = () => {
        const maxIndex = REVIEWS.length - itemsPerView;
        if (window.innerWidth <= 600) setCurrentIndex((prevIndex) => (prevIndex <= 0 ? maxIndex : prevIndex - 1));
        else if (window.innerWidth <= 900) setCurrentIndex((prevIndex) => (prevIndex <= 0 ? maxIndex : prevIndex - 2));
        else setCurrentIndex((prevIndex) => (prevIndex <= 0 ? maxIndex : prevIndex - 3));
    };

    return (
        <>
            {
                requestFormDisplay.status && (<div id='requestFormContainer'>
                    <RequestCallbackForm state={requestFormDisplay} func={handleRequestForm} serviceType={requestFormDisplay.data}></RequestCallbackForm>
                </div>)
            }

            {/* Banner Section*/}
            <HomePageBanner />
            {/* Banner Area -- New Banner*/}
            <div ref={bannerContainer} className={toggleModes.state === "light" ? 'newBannerContainer' : 'newBannerContainer dark'}>
                <div className='contentContainer'>
                    <div className='content'>
                        {/* <h5>Welcome to Finera</h5> */}
                        <h2>You've got a business,<br></br>we have got brilliant<br></br>minds.</h2>
                        <p>Our performance is your success. Our passion is innovation. Our expertise is unmatched. We get you more.</p>
                    </div>
                    <div className='buttonsContainer'>
                        <Link to={'/services&pricing'} className='button'>
                            <h4>Checkout Our Services</h4>
                        </Link>
                    </div>
                </div>
                <div className='modelContainer'>
                    <svg xmlSpace="preserve" width="56.3586mm" height="66.6248mm" version="1.1" style={{ shapeRendering: 'geometricPrecision', textRendering: 'geometricPrecision', imageRendering: 'optimizeQuality', fillRule: 'evenodd', clipRule: 'evenodd' }} viewBox="0 0 12040 14233" xmlnsXlink="http://www.w3.org/1999/xlink">
                        <defs>
                            <style type="text/css" dangerouslySetInnerHTML={{ __html: "\n                                \n                                .fil0 {fill:#07D589}\n   \n                            " }} />
                            <mask id="id0">
                                <linearGradient id="id1" gradientUnits="userSpaceOnUse" x1={7459} y1={-8106} x2={7459} y2={13789}>
                                    <stop offset={0} style={{ stopOpacity: 1, stopColor: 'white' }} />
                                    <stop offset="0.239216" style={{ stopOpacity: '39.651', stopColor: 'white' }} />
                                    <stop offset={1} style={{ stopOpacity: 0, stopColor: 'white' }} />
                                </linearGradient>
                                <rect style={{ fill: 'url(#id1)' }} x={-21} y={-21} width={12083} height={14276} />
                            </mask>
                            <mask id="id2">
                                <linearGradient id="id3" gradientUnits="userSpaceOnUse" x1={7070} y1={-10233} x2={7070} y2={13425}>
                                    <stop offset={0} style={{ stopOpacity: 1, stopColor: 'white' }} />
                                    <stop offset="0.0117647" style={{ stopOpacity: '39.651', stopColor: 'white' }} />
                                    <stop offset={1} style={{ stopOpacity: 0, stopColor: 'white' }} />
                                </linearGradient>
                                <rect style={{ fill: 'url(#id3)' }} x={1628} y={1628} width={8784} height={12605} />
                            </mask>
                        </defs>
                        <g id="PowerClip_x0020_Contents">
                            <metadata id="CorelCorpID_0Corel-Layer" />
                            <g id="_2000163518272">
                                <path className="fil0" style={{ mask: 'url(#id0)' }} d="M6020 0l0 0c3311,0 6020,2709 6020,6020l0 8213 -12040 0 0 -8213c0,-3311 2709,-6020 6020,-6020z" />
                                <path className="fil0" style={{ mask: 'url(#id2)' }} d="M10412 14233l0 -8213c0,-2412 -1980,-4392 -4392,-4392 -2412,0 -4392,1980 -4392,4392l0 8213 8784 0z" />
                            </g>
                        </g>
                    </svg>

                    <div className='imageContainer'>
                        <img src={BANNERMODEL} alt='model_img'></img>
                    </div>
                </div>
            </div>

            {/* Services Section */}
            <div ref={services} id='services' className={toggleModes.state === "light" ? 'services_section' : 'services_section dark'}>
                <div className='col1'>
                    <h2>The Services<br />
                        <span>We Offer For You</span> </h2>
                    <p> At Finera, we offer a wide array of services designed to meet the diverse needs of businesses across various industries. <br /> <br /> <span>Our Key Services include...</span> </p>
                    <ul>
                        <li>
                            <Link to={'/services&pricing'} state={{ searchItem: 'Tax Consultation' }} className='button'>
                                Tax Consultation
                            </Link>
                        </li>
                        <li>
                            <Link to={'/services&pricing'} state={{ searchItem: 'GST Registration' }} className='button'>
                                GST Registration
                            </Link>
                        </li>
                        <li>
                            <Link to={'/services&pricing'} state={{ category: 'IT Filing' }} className='button'>
                                ITR Filing
                            </Link>
                        </li>
                        <li>
                            <Link to={'/services&pricing'} state={{ searchItem: 'Trade License' }} className='button'>
                                Trade License
                            </Link>
                        </li>
                        <li>
                            <Link to={'/services&pricing'} state={{ searchItem: 'Food License' }} className='button'>
                                Food License
                            </Link>
                        </li>
                        <li>... and many more.</li>

                    </ul>

                    <Link to="/services&pricing" id='allServices' className="submit-button">ALL SERVICES
                    <FontAwesomeIcon icon={faAngleRight} className='fa'></FontAwesomeIcon>
                    </Link>
                </div>
                <div className='col2'>
                    <svg id="bg-services" viewBox="0 0 1000 800">
                        <defs>
                            <linearGradient id="PSgrad_02" x1="64.279%" x2="0%" y1="76.604%" y2="0%">
                                <stop offset="0%" stop-color="#11a770" stop-opacity="0.5"></stop>
                                <stop offset="100%" stop-color="#25ffaf" stop-opacity="1"></stop>
                            </linearGradient>
                        </defs>
                        <path fill-rule="evenodd" opacity={toggleModes.state === "light" ? "0.101" : "0.50"} fill="url(#PSgrad_02)" d="M801.878,3.146 L116.381,128.537 C26.052,145.060 -21.235,229.535 9.856,312.073 L159.806,710.157 C184.515,775.753 264.901,810.334 338.020,792.380 L907.021,652.668 C972.912,636.489 1019.383,573.766 1011.301,510.470 L962.013,124.412 C951.950,45.594 881.254,-11.373 801.878,3.146 Z"></path>
                    </svg>

                    <div className="service_col1">
                        <Link to={'/services&pricing'} state={{ searchItem: 'Tax Consultation' }}>
                            <div className="card_container">
                                <div className="image_container"><img className="" src={TAX} alt='card_img' /></div>
                                <div className="content_container">
                                    <h3 >Tax Consultancy</h3>
                                    <p >Navigating tax laws can be daunting. Our expert consultants provide personalized tax advice, helping you to optimize your tax liabilities and ensure compliance with all applicable regulations.</p>
                                </div>
                            </div>
                        </Link>
                        <Link to={'/services&pricing'} state={{ searchItem: 'GST Registration' }}>
                            <div className="card_container">
                                <div className="image_container"><img className="" src={GST} alt='card_img' /></div>
                                <div className="content_container">
                                    <h3 >GST Registration</h3>
                                    <p >GST compliance is crucial for businesses in India. We simplify the registration process, ensuring that your business is GST-compliant without any hassle.</p>
                                </div>
                            </div>
                        </Link>
                    </div>

                    <div className="service_col2">
                        <Link to={'/services&pricing'} state={{ category: 'IT Filing' }}>
                            <div className="card_container">
                                <div className="image_container"><img className="" src={ITR} alt='card_img' /></div>
                                <div className="content_container">
                                    <h3 >ITR Filing</h3>
                                    <p >Accurate and timely Income Tax Return (ITR) filing is essential for maintaining compliance and avoiding penalties. Our professionals handle your ITR filings, ensuring accuracy and timeliness.</p>
                                </div>
                            </div>
                        </Link>
                        <Link to={'/services&pricing'}>
                            <div className="card_container">
                                <div className="image_container"><img className="" src={MANYMORE} alt='card_img' /></div>
                                <div className="content_container">
                                    <h3 >.....and Many More</h3>
                                    <p >Beyond the core services, we offer a plethora of other legal solutions including business incorporation, intellectual property rights protection, and more. Whatever your legal needs, Finera has the expertise to assist you.</p>
                                </div>
                            </div>
                        </Link>
                    </div>
                </div>
            </div>

            {/* New Pricing Section */}
            <div ref={pricing} id='pricing' className={toggleModes.state === "light" ? 'new_pricing_section' : 'new_pricing_section dark'}>
                <div className='heading'>
                    <h4>Browse by <span>Categories</span></h4>
                    <p>Check the best Tax Service for you or your business.</p>
                </div>

                <div className='card_container'>
                    {
                        CATEGORIES.map((c) => (
                            <>
                                <div className='category_card'>
                                    <div className='circle' style={{ backgroundColor: toggleModes.state === "light" ? c.bgColor : c.bgColor.substring(0, c.bgColor.length - 2) + '82' }}></div>
                                    <div className='col1'>
                                        <h4>{c.title}</h4>
                                        <div className='body'>
                                            {
                                                c.items.map((i) => (
                                                    <>
                                                        <Link to={'/services&pricing'} state={i !== "Others" ? { searchItem: i } : { category: c.title }} className='button'>{i}</Link>
                                                    </>
                                                ))
                                            }
                                        </div>
                                        <Link to={'/services&pricing'} state={{ category: c.title }} href='#' className='link_button'>
                                            Explore Category
                                            <div className='arrow_btn' style={{ "--bgColor": toggleModes.state === "light" ? c.bgColor : c.bgColor.substring(0, c.bgColor.length - 2) + '82' }}>
                                                <FontAwesomeIcon icon={faArrowRight}></FontAwesomeIcon>
                                            </div>
                                        </Link>
                                    </div>
                                    <div className='col2'>
                                        <img src={c.icon} alt='icon'></img>
                                    </div>
                                </div>
                            </>
                        ))
                    }
                </div>
                <div className='footing'>
                    <Link to="/services&pricing" className="submit-button">EXPLORE Categories
                        {/* <i className="fa fa-angle-right" aria-hidden="true" /> */}
                        <FontAwesomeIcon icon={faArrowRight} className='fa'></FontAwesomeIcon>
                    </Link>
                </div>
            </div>

            {/* FAQ's Section */}
            <div ref={faq} className={toggleModes.state === "light" ? 'faq_section' : 'faq_section dark'}>
                <div className='heading'>
                    <h4>FAQ!  <span>Need Help?</span></h4>
                    <p>We've got you covered</p>
                </div>

                <div className='question_container'>
                    <div>
                        <input type='checkbox' id='first'></input>
                        <label htmlFor='first'>What is Finera?</label>
                        <div className='answer_content'>
                            <p>
                                <strong>Finera</strong> is the brand of Sohail Raza Consultancy Pvt. Ltd., a dynamic startup dedicated to providing comprehensive legal and financial solutions for businesses. Our services encompass a wide range of essential business needs, including GST registration and filing, Income Tax Return (ITR) filing, TDS compliance, trade licenses, food licenses, and various other legal solutions. At Finera, we strive to ensure that businesses navigate complex regulatory requirements with ease, allowing them to focus on their core operations. Our expert team is committed to delivering personalized and reliable support to help your business achieve compliance and growth.
                            </p>
                        </div>
                    </div>
                    <div>
                        <input type='checkbox' id='second'></input>
                        <label htmlFor='second'>What services does Finera offer?</label>
                        <div className='answer_content'>
                            <p>
                                <strong>Finera</strong> offers a comprehensive range of legal solutions tailored for businesses. Our services include: <br /><br />

                                1. GST Registration and Filing: Assisting businesses in registering for GST and managing their regular GST filings.<br />
                                2. Income Tax Return {"(ITR)"} Filing: Providing expert support for accurate and timely ITR filing.<br />
                                3. TDS Compliance: Ensuring businesses meet their TDS obligations with thorough preparation and filing.<br />
                                4. Licensing Services: Facilitating the acquisition of essential business licenses, such as Trade Licenses and Food Licenses.<br />
                                5. Many More: Offering a variety of additional legal and financial services to meet the unique needs of your business.
                            </p>
                        </div>
                    </div>
                    <div>
                        <input type='checkbox' id='third'></input>
                        <label htmlFor='third'>What is the application process of any service with Finera?</label>
                        <div className='answer_content'>
                            <p>
                                When a customer opts for a service with Finera, they can begin the application process by clicking on the <strong>"Request a Callback"</strong> option from the services menu. The customer will then fill out a form with their <strong>phone number, email ID, name, and any additional message</strong>. Once the form is submitted, <strong><em>our dedicated team will contact the customer within 24 hours via email or phone to discuss the service further and initiate the process.</em></strong><br /><br />

                                At <strong>Finera</strong>, we pride ourselves on our commitment to customer satisfaction and transparency. Our experienced professionals ensure that each step of the process is handled with the utmost care and efficiency. We understand the importance of trust in choosing a legal and financial partner, and we strive to build lasting relationships with our clients by delivering reliable and high-quality services.<br /><br />

                                Alternatively, customers are welcome to visit our office directly to speak with our team and start the application process in person. We are always ready to provide personalized support and address any questions or concerns.
                            </p>
                        </div>
                    </div>
                    <div>
                        <input type='checkbox' id='forth'></input>
                        <label htmlFor='forth'>How long does it take to complete my application?</label>
                        <div className='answer_content'>
                            <p>
                                The duration of the application process at Finera varies based on the specifics of each case and individual circumstances. Our team of experts will conduct a thorough assessment of your situation to provide you with an accurate estimate of the time required. We understand that time is of the essence, and our team is committed to working tirelessly to address your needs efficiently. After evaluating your case, we will communicate all necessary details and timelines to ensure you have a clear understanding of the process ahead. We are dedicated to providing timely and effective solutions while prioritizing the unique needs of your application.
                            </p>
                        </div>
                    </div>
                    <div>
                        <input type='checkbox' id='fifth'></input>
                        <label htmlFor='fifth'>Why should I choose Finera for my business’s legal solutions?</label>
                        <div className='answer_content'>
                            <p>
                                Choosing Finera for your business's legal solutions means partnering with a dedicated team of professionals who prioritize your success. Our comprehensive range of services is designed to meet the diverse needs of businesses at every stage. With our expertise in tax consultancy, compliance, and licensing, we provide tailored solutions that ensure your business operates smoothly and efficiently. Our commitment to exceptional customer service and transparency sets us apart, as we strive to build lasting relationships based on trust and reliability. By choosing Finera, you can focus on growing your business while we handle the complexities of legal matters.
                            </p>
                        </div>
                    </div>
                    <div>
                        <input type='checkbox' id='sixth'></input>
                        <label htmlFor='sixth'>How can I contact Finera for support or queries?</label>
                        <div className='answer_content'>
                            <p>
                                You can easily contact Finera for support or any queries by visiting our <a onClick={(e) => { e.preventDefault(); states('#contact') }} className='' href=''><strong>"Contact Us"</strong></a> section on the website. Here, you can submit your inquiries related to our services by providing your basic details, such as your email address and name. Our dedicated team will respond to you within 24 hours, ready to address all your questions and provide the assistance you need. We are here to help and ensure you have a seamless experience with our services.
                            </p>
                        </div>
                    </div>
                    <div>
                        <input type='checkbox' id='seventh'></input>
                        <label htmlFor='seventh'>What makes Finera different from other tax consultancy firms?</label>
                        <div className='answer_content'>
                            <p>
                                Finera stands out from other tax consultancy firms due to our unwavering commitment to personalized service and customer satisfaction. Our team of experienced professionals takes the time to understand each client's unique needs and challenges, allowing us to deliver tailored solutions that truly address their requirements.<br /><br />

                                Additionally, we prioritize transparency and communication, ensuring that our clients are informed and involved throughout the process. Our comprehensive range of services—from GST registration to ITR filing—coupled with our proactive approach to compliance, means we not only meet regulatory requirements but also help our clients achieve long-term financial success.
                            </p>
                        </div>
                    </div>
                </div>
            </div>

            {/* About Us Section */}
            <div ref={about} id='about' className={toggleModes.state === "light" ? "aboutus_section" : "aboutus_section dark"}>
                <div className='aboutus_content'>
                    <h1>About <span>Us</span></h1>
                    <p>Welcome to <strong>Finera</strong> - Your Trusted Partner for Business Legal Solutions! <br /> <br />

                        At <i><strong>Finera</strong></i>, we are dedicated to providing comprehensive and reliable legal solutions tailored to meet the diverse needs of businesses. Founded with the mission to simplify the complexities of legal compliance and regulatory requirements, we aim to be your go-to resource for all things legal and financial.
                        <br />
                        <i><strong>Finera</strong></i> was founded with a singular vision: to empower businesses by providing them with comprehensive, reliable, and efficient legal and financial solutions. Our team is comprised of seasoned professionals with extensive experience in tax consultancy, legal compliance, and business advisory services. We pride ourselves on our in-depth knowledge and commitment to excellence, which allows us to deliver top-notch services to our clients.
                    </p>
                </div>
            </div>

            {/* Why Choose Us Section */}
            <div ref={chooseUs} className={toggleModes.state === "light" ? 'chooseus_section' : 'chooseus_section dark'}>
                <div className='heading'>
                    <h4>Why <span>Choose</span> Us?</h4>
                    <p>Simplifying legal and financial complexities so businesses can grow.</p>
                </div>
                <div className='container'>
                    <div className='card'>
                        <div className='icon_container'>
                            <img src={toggleModes.state === "light" ? EXPERTISE : EXPERTISEWHITE} alt='icon_img'></img>
                        </div>
                        <h4>Expertise</h4>
                        <p>Our team of professionals brings a wealth of knowledge and experience in various domains of business law and finance.</p>
                    </div>
                    <div className='card'>
                        <div className='icon_container'>
                            <img src={COMMITMENT} alt='icon_img'></img>
                        </div>
                        <h4>Commitment</h4>
                        <p>We are dedicated to providing the highest level of service, ensuring that your business is always in compliance and positioned for success.</p>
                    </div>
                    <div className='card'>
                        <div className='icon_container'>
                            <img src={toggleModes.state === "light" ? FOCUS : FOCUSWHITE} alt='icon_img'></img>
                        </div>
                        <h4>Client Focus</h4>
                        <p>Your success is our success. We work closely with you to understand your needs and deliver solutions that align with your business objectives.</p>
                    </div>
                    <div className='card'>
                        <div className='icon_container'>
                            <img src={COMPREHENSIVE} alt='icon_img'></img>
                        </div>
                        <h4>comprehensive solutions</h4>
                        <p>We offer a full suite of services, covering all your business legal needs from setup to ongoing compliance.</p>
                    </div>
                    <div className='card'>
                        <div className='icon_container'>
                            <img src={toggleModes.state === "light" ? PROACTIVE : PROACTIVEWHITE} alt='icon_img'></img>
                        </div>
                        <h4>proactive approach</h4>
                        <p>We anticipate and address potential issues before they become problems, keeping you ahead of regulatory changes.</p>
                    </div>
                    <div className='card'>
                        <div className='icon_container'>
                            <img src={CUSTOMER} alt='icon_img'></img>
                        </div>
                        <h4>Customer centricity</h4>
                        <p>We prioritize your satisfaction with personalized attention and responsive support tailored to your business goals.</p>
                    </div>
                </div>
            </div>

            {/* Clients Section */}
            <div className={toggleModes.state === "light" ? 'clients_section' : 'clients_section dark'}>
                <h4 className='clients_heading'>Some of our <span>Clients</span></h4>
                <div className='logo_container'>
                    <div className='logo_card'>
                        <img src={CLIENT1} alt='client_logo'></img>
                    </div>
                    <div className='logo_card'>
                        <img src={CLIENT2} alt='client_logo'></img>
                    </div>
                    <div className='logo_card'>
                        <img src={CLIENT3} alt='client_logo'></img>
                    </div>
                    <div className='logo_card'>
                        <img src={CLIENT4} alt='client_logo'></img>
                    </div>
                    <div className='logo_card'>
                        <img src={CLIENT5} alt='client_logo'></img>
                    </div>
                    <div className='logo_card'>
                        <img src={CLIENT6} alt='client_logo'></img>
                    </div>

                    {/* part-2 */}
                    <div className='logo_card'>
                        <img src={CLIENT1} alt='client_logo'></img>
                    </div>
                    <div className='logo_card'>
                        <img src={CLIENT2} alt='client_logo'></img>
                    </div>
                    <div className='logo_card'>
                        <img src={CLIENT3} alt='client_logo'></img>
                    </div>
                    <div className='logo_card'>
                        <img src={CLIENT4} alt='client_logo'></img>
                    </div>
                    <div className='logo_card'>
                        <img src={CLIENT5} alt='client_logo'></img>
                    </div>
                    <div className='logo_card'>
                        <img src={CLIENT6} alt='client_logo'></img>
                    </div>
                </div>
            </div>

            {/* Testimonials Section */}
            <div ref={testimonials} className={toggleModes.state === "light" ? 'testimonials_section' : 'testimonials_section dark'}>
                <div className='testimonials_heading'>
                    <h4>Client <span>Testimonials</span></h4>
                    <p>Hear from our clients.</p>
                </div>

                <div className="carousel-container">
                    {
                        currentIndex > 0 && (
                            <button type="button" className="carousel-btn prev" onClick={handlePrev}>
                                <FontAwesomeIcon icon={faAngleLeft}></FontAwesomeIcon>
                            </button>
                        )
                    }
                    <div className="carousel-track" ref={trackRef}>
                        {REVIEWS.map((t, i) => (
                            <div className='testimonial_card'>
                                <div className='row1'>
                                    <div className='icon'>
                                        <FontAwesomeIcon icon={faQuoteLeft}></FontAwesomeIcon>
                                    </div>
                                    <p>
                                        {t.review}
                                    </p>
                                </div>
                                <div className='row2'>
                                    <div className='avatar'>
                                        <FontAwesomeIcon icon={faUser}></FontAwesomeIcon>
                                    </div>
                                    <div className='content'>
                                        <h4>{t.client_name}</h4>
                                        <p>{t.client_company_name}</p>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                    {
                        currentIndex < REVIEWS.length - itemsPerView && (
                            <button type="button" className="carousel-btn next" onClick={handleNext}>
                                <FontAwesomeIcon icon={faAngleRight}></FontAwesomeIcon>
                            </button>
                        )
                    }
                </div>
            </div>

            {/* Visit Us Section */}
            <div ref={visitUs} className={toggleModes.state === "light" ? 'visitus_section' : 'visitus_section dark'}>
                <h4 className='visitus_heading'>Visit <span>Us</span></h4>
                <div className='content_container'>
                    <div className='content'>
                        <div>
                            <h6>Office <span>Location</span></h6>
                            <p>61X, Topsia Rd, Topsia, Kolkata, West Bengal 700039</p>
                        </div>

                        <div>
                            <h6>Opening <span>Hours</span></h6>
                            <p>Mon-Sat: 10:00 AM to 8:00 PM <br /> Sun: Closed <br /> *On Holiday Occassions hours may vary*</p>
                        </div>

                        <div className='contact_gmail'>
                            <p>Contact: <span style={{ fontSize: 20 }}>contact@finera.net.in</span></p>
                        </div>
                    </div>
                    <div className='map'>
                        <iframe title='MAP' src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3685.156009049776!2d88.38534201113448!3d22.535827934231094!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3a027786cf5b3573%3A0x850ad0a527d38532!2sFinera!5e0!3m2!1sen!2sin!4v1724059741364!5m2!1sen!2sin" width={600} height={450} style={{ border: 0 }} allowFullScreen loading="lazy" referrerPolicy="no-referrer-when-downgrade" />
                    </div>
                </div>
            </div>

            <SideButtons toggleModes={{ state: toggleModes.state }}></SideButtons>
        </>
    )
}

export default Homepage